import axios from 'axios';
import Cookies from 'js-cookie';

import { VUE_APP_FILE_URL } from '@/utilities/constants.js';
const bearerToken = Cookies.get('bearerToken');

export const state = initialState();

export const actions = {
  uploadFile: async (_, payload) => {
    const { id, file, type } = payload;
    try {
      const res = await axios.post(`${VUE_APP_FILE_URL}/${type}/${id}`, file, {
        config: {
          headers: {
            'Content-Type': 'multipart/form-data',
            authorization: bearerToken
          }
        }
      });
      return res;
    } catch (err) {
      console.log(err);
      return;
    }
  },

  uploadChunkFile: async (_, payload) => {
    const {
      id,
      type,
      query,
      file,
      headers,
      projectId,
      createdStatus
    } = payload;

    try {
      //provisonal delete after testing/implementation is complete
      // throw new TypeError('no-storage-error');

      const params = { chunking: query, createdStatus: false };

      if (createdStatus) params.createdStatus = createdStatus;
      if (projectId) params['projectId'] = projectId;
      const res = await axios.post(
        `${VUE_APP_FILE_URL}/upload/${type}/${id}`,
        file,
        {
          params,
          headers: {
            authorization: bearerToken,
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'multipart/form-data',
            ...headers
          }
        }
      );
      return res;
    } catch (e) {
      if (e.message === 'no-storage-error') return 'no-storage-error';
      if (
        e.response.data.message.includes('insufficient cloud storage available')
      ) {
        return 'no-storage-error';
      }
    }
  }
};

export const mutations = {};

export const getters = {};

function initialState() {
  return {};
}
